import {
    EraroError,
    createEraroError,
    eraroCodesMap,
    isEraroError,
} from '@dazn/bootstrap-lib';

const getErrorMessage = (msg: string) => `Failed to load chapter. ${msg}`;

export class ResponseError extends EraroError {
    public readonly type = 'ResponseError';
}

export const isResponseError = (
    error: Error & { type?: string },
): error is ResponseError => error.type === 'ResponseError';

export const createResponseError = (response: Response, url: string) =>
    new ResponseError(
        getErrorMessage(`${response.status} ${response.statusText} at ${url}`),
        eraroCodesMap.category.ChapterLoading,
        eraroCodesMap.code.UnableToLoadChapter,
        String(response.status),
    );

export const createFetchChapterError = (
    message: string,
    internalCode: string,
    originalException?: Error,
) =>
    createEraroError(
        getErrorMessage(message),
        eraroCodesMap.category.ChapterLoading,
        eraroCodesMap.code.UnableToLoadChapter,
        internalCode,
        originalException,
    );

export const createCatchHandler =
    (msg: string, internal: string) => (ex: unknown) => {
        if (isEraroError(ex)) {
            throw ex;
        }
        const err = ex instanceof Error ? ex : new Error(String(ex));
        throw createFetchChapterError(msg, internal, err);
    };

export const createInvalidChapterError = (message: string) =>
    createEraroError(
        getErrorMessage(message),
        eraroCodesMap.category.ChapterLoading,
        eraroCodesMap.code.ChapterInvalid,
        eraroCodesMap.internal.GenericError,
    );
